// extracted by mini-css-extract-plugin
export default {"background":"prize-pool_background__5wvJG"};